import { useDisclosure } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { AddIcon } from "@looksrare/uikit";
import { Button, ButtonProps } from "uikit";
import { AddCollectionToWatchlistModal } from "components/Modals/AddCollectionToWatchlistModal";

export const AddCollectionToWatchlistButton = (props: ButtonProps) => {
  const { t } = useTranslation();

  const { isOpen, onOpen, onClose } = useDisclosure();
  return (
    <>
      <Button size="sm" leftIcon={<AddIcon />} onClick={onOpen} {...props}>
        {t("Add Collections")}
      </Button>
      <AddCollectionToWatchlistModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};
